/* eslint-disable react/jsx-props-no-spreading */
import { useSelector } from "react-redux";
import { Divider } from "staysure-component-library";

import { RootState } from "@/store/root-reducer";
import { Traveller } from "@/types/Traveller";
import { capitalizeFirstLetter } from "@/utils/common.utils";

import AccordionItemSection from "./accordion-item-section/accordion-item-section";

type MedicalAccordionSectionProps = {
  noMedicalCondition: string;
  oneMedicalCondition: string;
  multipleMedicalConditions: string;
};

function MedicalAccordionSection({
  noMedicalCondition,
  oneMedicalCondition,
  multipleMedicalConditions,
}: Readonly<MedicalAccordionSectionProps>) {
  const quote = useSelector((state: RootState) => state.quote);
  const { travellerDetails } = quote.attributes;

  const travellerDetailsMap = (traveller: Traveller) => {
    const medicalConditions = traveller?.medical?.condition ?? "";
    const medicals = medicalConditions.split("|").filter(Boolean);
    const count = medicals.length > 0 ? medicals.length.toString() : "";

    let prefix = "";
    if (medicals.length === 0) {
      prefix = noMedicalCondition;
    } else if (medicals.length === 1) {
      prefix = oneMedicalCondition;
    } else {
      prefix = multipleMedicalConditions;
    }

    const fullName = [
      capitalizeFirstLetter(traveller.firstName ?? ""),
      capitalizeFirstLetter(traveller.lastName ?? ""),
    ]
      .filter(Boolean)
      .join(" ");

    return {
      title: `${fullName}, ${count} ${prefix}`,
      medicals,
    };
  };

  return (
    <div className="md:mb-spacing-l">
      {travellerDetails?.traveller?.map((traveller, index) => (
        <div key={traveller.sequence}>
          <AccordionItemSection
            {...travellerDetailsMap(traveller)}
            isExpand={index === 0}
            id={`medical-${index}`}
          />
          <Divider margin={12} color="#DCDCDC" />
        </div>
      ))}
    </div>
  );
}

export default MedicalAccordionSection;
